export const DEFAULT_LOCALE = 'ru';
